import { RobotOutlined } from "@ant-design/icons";
import { Bubble } from "@ant-design/x";
import DOMPurify from "dompurify";
import { marked } from "marked";
import { useMemo } from "react";

interface AnalysisBubbleProps {
  content: string;
  loading?: boolean;
}

export const AnalysisBubble: React.FC<AnalysisBubbleProps> = ({ content, loading }) => {
  const html = useMemo(() => {
    if (!content) return "";
    return DOMPurify.sanitize(marked.parse(content, { async: false }) as string);
  }, [content]);

  return (
    <Bubble
      placement="start"
      loading={loading}
      avatar={<RobotOutlined />}
      content={content}
      variant="outlined"
      contentRender={() => (
        <div
          className="ai-analysis-markdown"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: markdown from trusted AI backend
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    />
  );
};
